import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = 'Convert GPA to Canadian Grading System';
const DESCRIPTION = "Learn how to convert your GPA to the Canadian grading system easily and accurately. Understand the Canadian university grading system.";
const KEYWORDS = "Canadian university system, GPA conversion, Canadian grading system, bachelor's GPA, master's GPA, university GPA, Canada";
const OG_URL = 'https://do-calculate.com/calculator/en/gradetocanada';
function GradeToCanada() {
  const [originalValue, setOriginalValue] = useState('');
  const [convertedValue, setConvertedValue] = useState('');
  const [conversionType, setConversionType] = useState('grade');
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToCanadianGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "A+";
    } else if (gpa >= 3.7 && gpa < 4.0) {
      return "A";
    } else if (gpa >= 3.3 && gpa < 3.7) {
      return "A-";
    } else if (gpa >= 3.0 && gpa < 3.3) {
      return "B+";
    } else if (gpa >= 2.7 && gpa < 3.0) {
      return "B";
    } else if (gpa >= 2.3 && gpa < 2.7) {
      return "B-";
    } else if (gpa >= 2.0 && gpa < 2.3) {
      return "C+";
    } else if (gpa >= 1.7 && gpa < 2.0) {
      return "C";
    } else if (gpa >= 1.3 && gpa < 1.7) {
      return "C-";
    } else if (gpa >= 1.0 && gpa < 1.3) {
      return "D+";
    } else if (gpa >= 0.7 && gpa < 1.0) {
      return "D";
    } else if (gpa >= 0.0 && gpa < 0.7) {
      return "F";
    } else {
      return 'Invalid input';
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === 'grade') {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 5).toFixed(2);
      }
    } else if (conversionType === 'gpa') {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToCanadianGrade(gpa);
      }
    }
    return 'Invalid input';
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue('');
    setConvertedValue('');
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Discover how to <strong>convert your university GPA</strong> (whether it's a percentage or cumulative) to the <strong>Canadian grading system</strong> with ease and precision using our advanced <strong>GPA conversion tool</strong>. This <strong>GPA calculator</strong> is designed to help you effortlessly <strong>convert GPA to the Canadian system</strong>, ensuring you get accurate results that align with Canadian academic standards. Whether you're a student transitioning to study in Canada, applying for scholarships, or need to <strong>convert your grades for academic or professional purposes</strong>, our <strong>GPA conversion tool</strong> provides reliable and precise information. Explore the details of the <strong>Canadian university grading system</strong> and use our tool to make informed decisions about your educational journey. This essential <strong>GPA calculator</strong> simplifies the process of understanding how your GPA translates into the Canadian grading framework, helping you navigate international academic requirements with confidence.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: '16px' }}>Convert GPA to Canadian System</h2>
                </div>
                <hr />
                <div className="form-group">
                  <b><label>Conversion Type:</label></b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === 'grade'}
                      onChange={() => handleConversionTypeChange('grade')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gradeConversion" className="form-check-label">Percentage (100)</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === 'gpa'}
                      onChange={() => handleConversionTypeChange('gpa')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">Cumulative (4.00)</label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b><label htmlFor='originalValue'>{conversionType === 'grade' ? 'Percentage:' : 'Cumulative GPA:'}</label></b>
                    <input
                      type="text"
                      value={originalValue}
                      id='originalValue'
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className='form-control'
                      style={{ width: '200px', marginRight: '4px' }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  Calculate                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && <div className="alert alert-warning"><b><u>Error:</u></b> {error}</div>}
                {showResult &&  (
                  <div style={{ fontSize: '15px' }} className="bg-light bg-gradient text-dark">
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>Result:</strong>
                    </div>
                    <b>
                      {conversionType === 'grade'
                        ? `The percentage equivalent for the Canadian system: ${convertedValue}`
                        : `The Canadian grade for your GPA: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={600}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Canadian University Grading System</h2></u>
                  <p>
                    In Canada, grades are classified on a scale from A+ to F, where A+ is the highest and F is the lowest. The grades can be broken down as follows:
                  </p>
                  <table >
                    <thead>
                      <tr className='bmi-header'>
                        <th>GPA (on a 4-point scale)</th>
                        <th>Canadian Grade</th>
                        <th>Equivalent Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>4.0</td>
                        <td>A+</td>
                        <td>90-100%</td>
                      </tr>
                      <tr>
                        <td>3.7 - 3.9</td>
                        <td>A</td>
                        <td>85-89%</td>
                      </tr>
                      <tr>
                        <td>3.3 - 3.6</td>
                        <td>A-</td>
                        <td>80-84%</td>
                      </tr>
                      <tr>
                        <td>3.0 - 3.2</td>
                        <td>B+</td>
                        <td>77-79%</td>
                      </tr>
                      <tr>
                        <td>2.7 - 2.9</td>
                        <td>B</td>
                        <td>73-76%</td>
                      </tr>
                      <tr>
                        <td>2.3 - 2.6</td>
                        <td>B-</td>
                        <td>70-72%</td>
                      </tr>
                      <tr>
                        <td>2.0 - 2.2</td>
                        <td>C+</td>
                        <td>67-69%</td>
                      </tr>
                      <tr>
                        <td>1.7 - 1.9</td>
                        <td>C</td>
                        <td>63-66%</td>
                      </tr>
                      <tr>
                        <td>1.3 - 1.6</td>
                        <td>C-</td>
                        <td>60-62%</td>
                      </tr>
                      <tr>
                        <td>1.0 - 1.2</td>
                        <td>D+</td>
                        <td>57-59%</td>
                      </tr>
                      <tr>
                        <td>0.7 - 0.9</td>
                        <td>D</td>
                        <td>53-56%</td>
                      </tr>
                      <tr>
                        <td>0.0 - 0.6</td>
                        <td>F</td>
                        <td>0-52%</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    This information helps understand how to convert GPAs to the Canadian system and know their English and percentage equivalents.
                  </p>
                  <b className='text-primary'>
                    <span>Example: </span>
                    If you have a GPA of 3.0 on a 4.0 scale, you can convert it to the Canadian system using the tool above and get the equivalent result.
                  </b>
                  <p>
                    This tool is very useful for international students who want to pursue their studies in Canada or apply for jobs that require a certain academic GPA.
                  </p>
                  <div>
                    <p>
                      Canada is among the leading countries in education, with many prestigious universities attracting students from all over the world.
                    </p>
                    <p className='alert alert-info'>
                      Canada has many globally ranked universities, and the academic system in Canadian universities is known for its scientific rigor and innovative curricula. The tuition costs in Canada are reasonable compared to other European countries and the United States.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GradeToCanada;
